define("shared/components/shared/restricted-area/body", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <p class="u--m__b__lg">
    {{@feature.body}}
    {{#if @feature.needsUpgrade}}
      {{@feature.needsUpgradeText}}
      <br />
    {{/if}}
    {{#if @feature.link}}
      <a class="qa--connectSocial_learnMore_Btn" href={{@feature.link}} rel="noopener noreferrer" target="_blank">
        {{@feature.linkText}}
      </a>
    {{/if}}
  </p>
  {{#if (and @feature.needsUpgrade this.hasSupportedSocialProfiles)}}
    <Shared::Button::Upgrade
      @additional="block"
      @feature={{@feature.feature}}
      @location={{@feature.location}}
      @seamlessCheckoutSuccessCallback={{@seamlessCheckoutSuccessCallback}}
      @text={{t "shared_phrases.upgrade_plan"}}
    />
  {{else if @actionText}}
    <Shared::Ui::Button
      @additional="block"
      @class={{unless this.hasSupportedSocialProfiles "qa--connectSocial_addProfile_Btn" ""}}
      @isDisabled={{@isDisabled}}
      @onClick={{@actionMethod}}
      @text={{@actionText}}
    />
    <span class="u--text--light u--text--sm">
      {{@additionalButtonText}}
    </span>
  {{/if}}
  */
  {
    "id": "cUVmQNMj",
    "block": "[[[10,2],[14,0,\"u--m__b__lg\"],[12],[1,\"\\n  \"],[1,[30,1,[\"body\"]]],[1,\"\\n\"],[41,[30,1,[\"needsUpgrade\"]],[[[1,\"    \"],[1,[30,1,[\"needsUpgradeText\"]]],[1,\"\\n    \"],[10,\"br\"],[12],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"link\"]],[[[1,\"    \"],[10,3],[14,0,\"qa--connectSocial_learnMore_Btn\"],[15,6,[30,1,[\"link\"]]],[14,\"rel\",\"noopener noreferrer\"],[14,\"target\",\"_blank\"],[12],[1,\"\\n      \"],[1,[30,1,[\"linkText\"]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\"],[41,[28,[37,1],[[30,1,[\"needsUpgrade\"]],[30,0,[\"hasSupportedSocialProfiles\"]]],null],[[[1,\"  \"],[8,[39,2],null,[[\"@additional\",\"@feature\",\"@location\",\"@seamlessCheckoutSuccessCallback\",\"@text\"],[\"block\",[30,1,[\"feature\"]],[30,1,[\"location\"]],[30,2],[28,[37,3],[\"shared_phrases.upgrade_plan\"],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,3],[[[1,\"  \"],[8,[39,4],null,[[\"@additional\",\"@class\",\"@isDisabled\",\"@onClick\",\"@text\"],[\"block\",[52,[51,[30,0,[\"hasSupportedSocialProfiles\"]]],\"qa--connectSocial_addProfile_Btn\",\"\"],[30,4],[30,5],[30,3]]],null],[1,\"\\n  \"],[10,1],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n    \"],[1,[30,6]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[]]]],[\"@feature\",\"@seamlessCheckoutSuccessCallback\",\"@actionText\",\"@isDisabled\",\"@actionMethod\",\"@additionalButtonText\"],false,[\"if\",\"and\",\"shared/button/upgrade\",\"t\",\"shared/ui/button\",\"unless\"]]",
    "moduleName": "shared/components/shared/restricted-area/body.hbs",
    "isStrictMode": false
  });
  let RestrictedAreaComponent = _exports.default = (_class = class RestrictedAreaComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
    }
    get hasSupportedSocialProfiles() {
      if (!this.args.feature.supportedSocialProfiles.length) {
        return true;
      }
      const socialProfiles = this.auth.currentGroup.socialProfiles.map(socialProfile => socialProfile.profileType);
      return this.args.feature.supportedSocialProfiles.some(sp => socialProfiles.includes(sp));
    }
    get canTrial() {
      return this.auth.currentAccount?.canTrialPlan ?? false;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, RestrictedAreaComponent);
});